const { api } = window.__DATA__;

class FeedbackService {
  // postJson("<%= API %>/<%= eventId %>/event/<%= feedbackId %>/workshops/<%= workshopId %>/grade?token=" + token + "&userId=" + userId, result, function (err,
  async postForm(data: any) {
    return fetch(api.feedback, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((res) => res.json());
  }
}

const feedbackService = new FeedbackService();
export default feedbackService;
